import {GetterTree} from "vuex";
import {OriginatorRulesState} from "@/store/rules/originator_rules/types";
import {RootState} from "@/store/types";

export const getters: GetterTree<OriginatorRulesState, RootState> = {
  originatorRules: state => state.originatorRules,
  originatorRuleItem: state => state.originatorRuleItem
}